import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AdvertStatusList.css';

class AdvertStatusList extends React.Component {
  static propTypes = {
    statuses: PropTypes.arrayOf(
      PropTypes.shape({
        slug: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        title: PropTypes.string.isRequired,
      }),
    ),
    className: PropTypes.string.isRequired,
  };
  static defaultProps = {
    statuses: [],
    className: '',
  };

  render() {
    const { statuses, className } = this.props;

    return (
      statuses.length > 0 && (
        <div className={className}>
          <div className={s.statusList}>
            {statuses.map(status => (
              <div className={s.statusItem} key={status.id || status.title}>
                {status.title}
              </div>
            ))}
          </div>
        </div>
      )
    );
  }
}

export default withStyles(s)(AdvertStatusList);



// WEBPACK FOOTER //
// ./src/shared/components/AdvertStatusList/AdvertStatusList.js